import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
import merge from 'lodash/merge';
import { generateExternalStyle } from './externalStyles';
var generateStyle = function generateStyle(componentTheme, props) {
  var mq = "@media screen and (".concat(componentTheme.phoneBreakPoint, ")");
  var mp = '@media print';
  return merge({
    sidebar: _objectSpread(_objectSpread(_defineProperty({
      boxSizing: 'border-box',
      width: componentTheme.sidebarWidthClosed,
      backgroundColor: componentTheme.sidebarBackgroundColor,
      color: componentTheme.sidebarColor,
      height: '100%',
      overflow: 'hidden',
      position: 'relative',
      zIndex: componentTheme.sidebarZIndex,
      transition: "".concat(componentTheme.sidebarTransitionDuration, " ease")
    }, mq, {
      position: 'absolute',
      width: 0
    }), props.sidebarOpen && _defineProperty({
      width: componentTheme.sidebarWidthOpen,
      opacity: 1
    }, mq, {
      width: '100vw',
      maxWidth: '100vw'
    })), {}, {
      description: _objectSpread({
        color: componentTheme.descriptionFontColor,
        display: 'none',
        fontSize: componentTheme.descriptionFontSize
      }, props.sidebarOpen && {
        cursor: 'pointer',
        display: 'inline-block'
      }),
      actionableInfo: _objectSpread({
        borderBottom: "".concat(componentTheme.sidebarHeaderBorderWidth, " solid ").concat(componentTheme.sidebarHeaderBorderColor),
        borderRight: "".concat(componentTheme.actionableInfoBorderWidth, " solid ").concat(componentTheme.sidebarBackgroundColor),
        textAlign: 'center',
        ':hover': {
          borderRight: "".concat(componentTheme.actionableInfoBorderWidth, " solid ").concat(componentTheme.actionableInfoHoverBorderColor)
        }
      }, props.sidebarOpen && {
        textAlign: 'inherit'
      })
    }),
    /* Decrease z-index when RCE editor is in fullscreen mode */
    globalStyles: {
      sidebar: {
        zIndex: 0
      }
    },
    sidebarWrapper: {
      display: 'flex',
      flexDirection: 'column',
      height: '100%'
    },
    sidebarContent: {
      overflowY: 'auto',
      overflowX: 'hidden'
    },
    headerSpacing: {
      display: 'flex',
      flexDirection: 'row',
      padding: componentTheme.headerSpacingPadding,
      flexShrink: 0,
      h2: {
        paddingTop: '0.3em'
      }
    },
    headerBottomBorder: {
      borderBottom: "solid ".concat(componentTheme.sidebarHeaderBorderWidth),
      borderColor: componentTheme.sidebarHeaderBorderColor
    },
    iconWrapper: _objectSpread({
      marginLeft: 'auto'
    }, !props.sidebarOpen && {
      display: 'block',
      margin: 'auto'
    }),
    pinnedSection: {
      width: '100%',
      backgroundColor: componentTheme.pinnedSectionBackgroundColor,
      headerSpacing: {
        flexGrow: 1
      }
    },
    questionNavigatorPadding: _objectSpread({
      paddingTop: componentTheme.questionNavigatorPadding
    }, !props.sidebarOpen && {
      display: 'none'
    }),
    buttonWrapper: _objectSpread({
      button: {
        paddingLeft: componentTheme.pinnedQuestionSpacing,
        paddingBottom: componentTheme.pinnedQuestionSpacing,
        fontSize: componentTheme.pinnedQuestionFontSize,
        display: 'block'
      }
    }, !props.sidebarOpen && {
      display: 'none'
    }),
    commonContainer: _defineProperty(_defineProperty({
      height: '100%'
    }, mq, {
      position: 'relative'
    }), mp, {
      display: 'none'
    })
  }, generateExternalStyle(componentTheme));
};
export default generateStyle;